// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. See full license in the root of the repo.
/*
    This file provides the provides functionality to get Microsoft Graph data.
*/

import { showMessage } from "./message-helper";
import * as $ from "jquery";

// Used by the MSAL fallback dialog to verify the token works with the middle-tier
export async function callGetUserData(middletierToken: string): Promise<any> {
  try {
    const data = await $.ajax({
      type: "GET",
      url: `/fetchCountryCode`,
      headers: { Authorization: "Bearer " + middletierToken },
      cache: false,
    });
    return data;
  } catch (err) {
    showMessage(`Error from middle tier. \n${err.responseText || err.message}`);
    throw err;
  }
}

export async function getCountries(middletierToken: string): Promise<any> {
  try {
    const countryData = await $.ajax({
      type: "GET",
      url: `/fetchCountryCode`,
      headers: { Authorization: "Bearer " + middletierToken },
      cache: false,
    });
    return countryData;
  } catch (err) {
    showMessage(`Error from middle tier. \n${err.responseText || err.message}`);
    throw err;
  }
}

export async function sendDocuments(
  documents: any,
  middletierToken: string,
  selectedCountryCode: string,
): Promise<any> {
  try {
    const documentIds = await $.ajax({
      type: "POST",
      url: `/documents`,
      headers: {
        Authorization: "Bearer " + middletierToken,
        "Gemisoft-User-department": selectedCountryCode,
      },
      cache: false,
      data: documents,
      processData: false,
      contentType: false,
    });
    return documentIds;
  } catch (err) {
    showMessage(`Error from middle tier. \n${err.responseText || err.message}`);
    throw err;
  }
}

export async function getBranches(middletierToken: string): Promise<any> {
  try {
    const branchData = await $.ajax({
      type: "GET",
      url: `/fetchBranches`,
      headers: { Authorization: "Bearer " + middletierToken },
      cache: false,
    });
    return branchData;
  } catch (err) {
    showMessage(`Error from middle tier. \n${err.responseText || err.message}`);
    throw err;
  }
}

export async function sendContract(
  contractDocument: FormData,
  middletierToken: string,
): Promise<any> {
  try {
    const contractResponse = await $.ajax({
      type: "POST",
      url: `/contract`,
      headers: {
        Authorization: "Bearer " + middletierToken,
      },
      cache: false,
      data: contractDocument,
      processData: false,
      contentType: false,
    });
    return contractResponse;
  } catch (err) {
    showMessage(`Error from middle tier. \n${err.responseText || err.message}`);
    throw err;
  }
}
